import { useApiMutation, useApiQuery } from '../../scripts/api/api_v2';
import { useEffect, useRef, useState } from 'react';
import { CardProfileTable } from './CardProfileTable';
import { Page } from '../../components/root/Page';
import { sleep } from '../../scripts/scripts';
import toast from 'react-hot-toast';
import { useLoadingStore } from '../../store/useLoadingStore';
import { ModalImportCards } from './ModalImportCards';
import _ from 'lodash';
import { useSingleSelectionStore } from '../../store/useSingleSelectionStore';
import { CardProfile } from '../../types/CardProfile';

export function CardsPage() {
	const [addCardsModal, setAddCardsModal] = useState<boolean>(false);

	// TODO: Add loading animation
	const { data, fetchData } = useApiQuery('card.list', {}, { enabled: true });

	const { fetchData: deleteCardsAPI } = useApiMutation('card.delete');

	const [cachedData, setCachedData] = useState<{ cards: CardProfile[] } | undefined>(undefined);
	const { selection, clearSelection } = useSingleSelectionStore();
	const { setRemovingSeatsLoading } = useLoadingStore();
	const deletingSeatsRef = useRef<boolean>(false);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	useEffect(() => {
		setCachedData(data);
	}, [data]);

	// NOTE: API Handlers
	const onDeleteCards = async ({ cardIds }: { cardIds: CardProfile['id'][] }) => {
		if (deletingSeatsRef.current) return;
		setRemovingSeatsLoading(true);
		deletingSeatsRef.current = true;

		await sleep(500);
		try {
			const res = await deleteCardsAPI({
				body: {
					cardIds,
				},
			});
			if (!res?.success) {
				console.error(res?.error);
				toast.error(res?.error ?? `Failed to delete cards!`);
				return;
			}
			setCachedData((state) => {
				if (!state) return state;
				return _.cloneDeep({ cards: state.cards.filter((card) => !cardIds.includes(card.id)) });
			});
			return true;
		} catch (err) {
			console.error(err);
			toast.error(err?.toString() ?? 'Undefined error occured when trying to edit order');
			return;
		} finally {
			setRemovingSeatsLoading(false);
			deletingSeatsRef.current = false;
		}
	};

	// NOTE: Actions toolbar
	const onClickDeleteCards = async () => {
		const selectedSeatIdsArray = Object.keys(selection);
		if (selectedSeatIdsArray.length < 1) return;

		const isSaved = await onDeleteCards({
			cardIds: selectedSeatIdsArray,
		});
		if (isSaved) {
			toast.success('Selected cards deleted!');
			clearSelection();
		}
	};

	const nOrdersSelected = Object.entries(selection).filter((idPair) => idPair[1]);

	const pageActions = [
		{ text: 'Add Cards', action: () => setAddCardsModal(true) },
		{ text: 'Delete Cards', action: () => onClickDeleteCards(), disabled: nOrdersSelected.length < 1 },
	];

	return (
		<>
			{addCardsModal && <ModalImportCards closeModal={() => setAddCardsModal(false)} />}
			<Page actions={pageActions}>
				<CardProfileTable cards={cachedData} />
			</Page>
		</>
	);
}
